export const validateParams = (required: string[], params: any = {
}) => {
  const missing = required.reduce((p, q) => {
    if (
      !params[q]
      || params[q] === undefined
      || (Array.isArray(params[q]) && params[q].length === 0)
    ) return p.concat([q])
    return p
  }, [])
  if (missing.length > 0) return missing.join(', ')
  return ''
}

export const required = (value: any) => (value ? undefined : 'Required')

export const maxLength = (max: number) => (value: string) => (value && value.length > max ? `Must be ${max} characters or less` : undefined)

export const minLength = (min: number) => (value: string) => (value && value.length < min ? `Must be at least ${min} characters` : undefined)

export const isNumber = (value: any) => (value && Number.isNaN(Number(value)) ? 'Must be a number' : undefined)

export const minValue = (min: number) => (value: number) => (value && value < min ? `Must be at least ${min}` : undefined)

export const validatePhoneNumber = (number) => (number
  && /^\s*$^\d{10}$|^(?:(\+1 ){0,1}(?:\(\d{3}\)|(?:\d{3}))(?:\s|\-){0,1}(?:\d{3})(?:\s|\-){0,1})(?:\d{4})$/
    .test(number.trim())
)

export const emailValid = (value: string) => (value
  // eslint-disable-next-line max-len
  && /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    .test(value))

export const ssnValid = (value: string) => (value
  && /^[0-9]{3}[-][0-9]{2}[-][0-9]{4}$/
    .test(value))

export const zipValid = (value: string) => (value
  && /^[0-9]{5}$/
    .test(value))

// export const aol = value =>
//     value && /.+@aol\.com/.test(value) ?
//         'Really? You still use AOL for your email?' : undefined

export const USStates: { abbr: string, name: string }[] = [
  { abbr: 'AL', name: 'Alabama' },
  { abbr: 'AK', name: 'Alaska' },
  { abbr: 'AS', name: 'American Samoa' },
  { abbr: 'AZ', name: 'Arizona' },
  { abbr: 'AR', name: 'Arkansas' },
  { abbr: 'CA', name: 'California' },
  { abbr: 'CO', name: 'Colorado' },
  { abbr: 'CT', name: 'Connecticut' },
  { abbr: 'DE', name: 'Delaware' },
  { abbr: 'DC', name: 'District Of Columbia' },
  { abbr: 'FM', name: 'Federated States Of Micronesia' },
  { abbr: 'FL', name: 'Florida' },
  { abbr: 'GA', name: 'Georgia' },
  { abbr: 'GU', name: 'Guam' },
  { abbr: 'HI', name: 'Hawaii' },
  { abbr: 'ID', name: 'Idaho' },
  { abbr: 'IL', name: 'Illinois' },
  { abbr: 'IN', name: 'Indiana' },
  { abbr: 'IA', name: 'Iowa' },
  { abbr: 'KS', name: 'Kansas' },
  { abbr: 'KY', name: 'Kentucky' },
  { abbr: 'LA', name: 'Louisiana' },
  { abbr: 'ME', name: 'Maine' },
  { abbr: 'MH', name: 'Marshall Islands' },
  { abbr: 'MD', name: 'Maryland' },
  { abbr: 'MA', name: 'Massachusetts' },
  { abbr: 'MI', name: 'Michigan' },
  { abbr: 'MN', name: 'Minnesota' },
  { abbr: 'MS', name: 'Mississippi' },
  { abbr: 'MO', name: 'Missouri' },
  { abbr: 'MT', name: 'Montana' },
  { abbr: 'NE', name: 'Nebraska' },
  { abbr: 'NV', name: 'Nevada' },
  { abbr: 'NH', name: 'New Hampshire' },
  { abbr: 'NJ', name: 'New Jersey' },
  { abbr: 'NM', name: 'New Mexico' },
  { abbr: 'NY', name: 'New York' },
  { abbr: 'NC', name: 'North Carolina' },
  { abbr: 'ND', name: 'North Dakota' },
  { abbr: 'MP', name: 'Northern Mariana Islands' },
  { abbr: 'OH', name: 'Ohio' },
  { abbr: 'OK', name: 'Oklahoma' },
  { abbr: 'OR', name: 'Oregon' },
  { abbr: 'PW', name: 'Palau' },
  { abbr: 'PA', name: 'Pennsylvania' },
  { abbr: 'PR', name: 'Puerto Rico' },
  { abbr: 'RI', name: 'Rhode Island' },
  { abbr: 'SC', name: 'South Carolina' },
  { abbr: 'SD', name: 'South Dakota' },
  { abbr: 'TN', name: 'Tennessee' },
  { abbr: 'TX', name: 'Texas' },
  { abbr: 'UT', name: 'Utah' },
  { abbr: 'VT', name: 'Vermont' },
  { abbr: 'VI', name: 'Virgin Islands' },
  { abbr: 'VA', name: 'Virginia' },
  { abbr: 'WA', name: 'Washington' },
  { abbr: 'WV', name: 'West Virginia' },
  { abbr: 'WI', name: 'Wisconsin' },
  { abbr: 'WY', name: 'Wyoming' },
]

export const findUSState = (state) => {
  if (!state) return undefined
  const st = state.length === 2
    ? USStates.find((entry) => entry.abbr.toLowerCase() === state.toLowerCase())
    : USStates.find((entry) => entry.name.toLowerCase() === state.toLowerCase())
  return st
}

export const validatePayment = (payment, addMethod?) => {
  if (payment.payment_method === 'ACH') {
    if (!payment.account_name || !payment.account_number || !payment.account_routing) {
      return { valid: false, message: `Submitted ACH payment ${addMethod ? 'method ' : ''}without all the required account information` }
    }
  }
  if (payment.payment_method === 'Chase_Quick_Pay') {
    if (!payment.quick_pay_via || !payment.quick_pay_info) {
      return { valid: false, message: `Submitted Zelle payment ${addMethod ? 'method ' : ''}without all the information` }
    }
  }
  if (payment.payment_method === 'Check') {
    if (!payment.check_name || !payment.check_number) {
      return { valid: false, message: 'Submitted check payment without all the check information' }
    }
  }
  return { valid: true, message: '' }
}
